import React from "react";
import { observer } from "mobx-react";
import { MessageAuthor } from "../Models/MessageAuthor";
import { Grid, Skeleton } from "@mui/material";
import { sxClsx } from "utils/styleClsx";
import { AgentAvatar } from "../Branding/AgentAvatar";

export const AgentConversationSkeleton = observer(
    ({ fullscreen }: { fullscreen?: boolean }) => {
        return (
            <>
                <Grid
                    container
                    item
                    direction="column"
                    flexWrap="nowrap"
                    rowGap={3}
                    flexGrow={1}
                    paddingInline={2}
                    sx={sxClsx(
                        { height: "100%" },
                        fullscreen && { maxWidth: "75%" },
                    )}
                >
                    {[
                        MessageAuthor.User,
                        MessageAuthor.Agent,
                        MessageAuthor.User,
                    ].map((author, index) => {
                        return (
                            <MessageGroupPlaceholder
                                key={`agent-chat-${index}`}
                                author={author}
                                maxMessageWidth={
                                    fullscreen
                                        ? "calc(max(60%, 400px))"
                                        : "calc(max(80%, 300px))"
                                }
                            />
                        );
                    })}
                </Grid>
                <Skeleton
                    sx={sxClsx(
                        { bottom: 0 },
                        fullscreen && {
                            maxWidth: "77%",
                            width: "77%",
                            height: "90px",
                        },
                    )}
                    className={"pendo-ignore"}
                />
            </>
        );
    },
);

const MessageGroupPlaceholder = observer(
    ({
        author,
        maxMessageWidth,
        ...props
    }: React.ComponentPropsWithoutRef<typeof Grid> & {
        author: MessageAuthor;
        maxMessageWidth: string;
    }) => {
        const isUserMessage = author === MessageAuthor.User;
        const isAgentMessage = author === MessageAuthor.Agent;

        return (
            <Grid
                container
                item
                direction="column"
                flexWrap="nowrap"
                gap={1}
                alignSelf={isUserMessage ? "self-end" : "self-start"}
                width={maxMessageWidth}
                {...props}
            >
                <Grid
                    container
                    item
                    alignItems="flex-end"
                    flexWrap="nowrap"
                    gap={1}
                >
                    {isAgentMessage && (
                        <Grid item>
                            <AgentAvatar />
                        </Grid>
                    )}
                    <Grid
                        container
                        item
                        direction="column"
                        rowGap={1}
                        flexWrap="nowrap"
                        alignItems={isUserMessage ? "flex-end" : "flex-start"}
                    >
                        {isUserMessage ? (
                            <Skeleton
                                width={maxMessageWidth}
                                height={75}
                                sx={{
                                    borderRadius: 2,
                                    borderBottomRightRadius: 0,
                                }}
                            />
                        ) : (
                            <Skeleton
                                width={maxMessageWidth}
                                height={75}
                                sx={{
                                    borderRadius: 2,
                                    borderBottomLeftRadius: 0,
                                }}
                            />
                        )}
                    </Grid>
                </Grid>
            </Grid>
        );
    },
);
